import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { baseStyles, buttonStyles } from '@/styles';

@customElement('fg-accordion')
export class FgAccordion extends LitElement {
  render() {
    return html`
      <div class="accordion">
        <slot name="accordion-content"></slot>
        <slot name="accordion-footer"></slot>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      .accordion {
        position: relative;
      }
    `,
  ];
}
